var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStays = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 22.15v-4.2c0-1.2 1-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1v4.3H9.9z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 1.55 1 22.45h22z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.4 17.45h-3.1v3.1h3.1zM10 17.45H6.9v3.1H10zM6.2 13.05h11.5M10 12.75v-6.9M3.6 17.05V6.65M14.1 12.55v-6.9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgStays;